import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deleteConfirmationText: {
    defaultMessage: 'iBeacon will be removed. Are you sure?',
    id: 'iBeacon.delete.dialog.text',
  },
});
